import React from 'react';
import { FormattedMessage } from '@99designs/frontend-components/i18n';
import { Answer } from '../../components/Step/Answer';
import { getIndustryLabel } from '../../utils/industries';
import type { StepHeadingProps } from '../../components/Onboarder/Config';
import type { SelectedValues } from '../config';

export const questionCopy = () => __('My business is in the {answer} industry');

export function IndustryStepHeading({ data }: StepHeadingProps<SelectedValues>) {
    const answer = getIndustryLabel(data.industry);

    return (
        <span>
            <FormattedMessage
                message={questionCopy()}
                values={{ answer: <Answer text={answer} /> }}
            />
        </span>
    );
}
